module.exports = __webpack_public_path__ + "static/media/bn-mockup-2.978cd4b6.jpg";